import React, { useEffect, useState } from "react";
import SpinnerAbsolute from "../components/UI/SpinnerAbsolute";
import GeoBlocked from "../components/UI/GeoBlocked";
import { checkGeoAccess } from "../helpers/geoAccess";

// Children (which load the event) only mount once the viewer passes the event's country/IP restriction.
const GeoGate = ({ eventId, children }) => {
  const [result, setResult] = useState({ eventId: null, access: null });

  useEffect(() => {
    let cancelled = false;
    checkGeoAccess(eventId).then((access) => {
      if (!cancelled) setResult({ eventId, access });
    });
    return () => {
      cancelled = true;
    };
  }, [eventId]);

  if (result.eventId !== eventId) return <SpinnerAbsolute />;
  if (!result.access) return <GeoBlocked />;
  return children;
};

export default GeoGate;
